export interface UserFormResults {
  metier?: string;
  targetAudience?: string;
  // Legacy fields (backward compat with existing conversations)
  followUp?: string;
  formateurQuestion?: string;
  developpeurQuestion?: string;
  ahouQuestion?: string;
}

export interface AiProfile {
  metier?: string;
  targetAudience?: string;
}

export interface ChatState {
  userFormResults: UserFormResults;
  userPrompt: string;
}

export const initialState: ChatState = {
  userFormResults: {},
  userPrompt: "",
};

export const updateChatState = (state: ChatState, key: keyof UserFormResults, value: string) => {
  return { ...state, userFormResults: { ...state.userFormResults, [key]: value } };
};
